/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CheckRunScheduleRequest } from '../model/checkRunScheduleRequest';
import { CheckRunScheduleView } from '../model/checkRunScheduleView';
import { ScheduleErrorResponse } from '../model/scheduleErrorResponse';
import { SchedulePreviewView } from '../model/schedulePreviewView';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CheckRunScheduleControllerService {

    protected basePath = 'https://api.beta.planbic.de';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Zeitplan anlegen; der Aufrufer wird ausführender Nutzer
     * 
     * @param body 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createCheckRunSchedule(body: CheckRunScheduleRequest, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<CheckRunScheduleView>;
    public createCheckRunSchedule(body: CheckRunScheduleRequest, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CheckRunScheduleView>>;
    public createCheckRunSchedule(body: CheckRunScheduleRequest, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CheckRunScheduleView>>;
    public createCheckRunSchedule(body: CheckRunScheduleRequest, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createCheckRunSchedule.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling createCheckRunSchedule.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CheckRunScheduleView>('post',`${this.basePath}/workflows/check-run-schedules`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Zeitplan löschen
     * 
     * @param projectId 
     * @param scheduleId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteCheckRunSchedule(projectId: number, scheduleId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteCheckRunSchedule(projectId: number, scheduleId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteCheckRunSchedule(projectId: number, scheduleId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteCheckRunSchedule(projectId: number, scheduleId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteCheckRunSchedule.');
        }

        if (scheduleId === null || scheduleId === undefined) {
            throw new Error('Required parameter scheduleId was null or undefined when calling deleteCheckRunSchedule.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/workflows/check-run-schedules/${encodeURIComponent(String(scheduleId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Zeitpläne des Projekts, nach nächster Ausführung sortiert
     * 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listCheckRunSchedules(projectId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<CheckRunScheduleView>>;
    public listCheckRunSchedules(projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CheckRunScheduleView>>>;
    public listCheckRunSchedules(projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CheckRunScheduleView>>>;
    public listCheckRunSchedules(projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling listCheckRunSchedules.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<CheckRunScheduleView>>('get',`${this.basePath}/workflows/check-run-schedules`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Zeitplan pausieren
     * 
     * @param projectId 
     * @param scheduleId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pauseCheckRunSchedule(projectId: number, scheduleId: string, observe?: 'body', reportProgress?: boolean): Observable<CheckRunScheduleView>;
    public pauseCheckRunSchedule(projectId: number, scheduleId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CheckRunScheduleView>>;
    public pauseCheckRunSchedule(projectId: number, scheduleId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CheckRunScheduleView>>;
    public pauseCheckRunSchedule(projectId: number, scheduleId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling pauseCheckRunSchedule.');
        }

        if (scheduleId === null || scheduleId === undefined) {
            throw new Error('Required parameter scheduleId was null or undefined when calling pauseCheckRunSchedule.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<CheckRunScheduleView>('post',`${this.basePath}/workflows/check-run-schedules/${encodeURIComponent(String(scheduleId))}/pause`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Zeitplan prüfen ohne zu speichern: nächste Termine und Hinderungsgründe
     * 
     * @param body 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public previewCheckRunSchedule(body: CheckRunScheduleRequest, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<SchedulePreviewView>;
    public previewCheckRunSchedule(body: CheckRunScheduleRequest, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SchedulePreviewView>>;
    public previewCheckRunSchedule(body: CheckRunScheduleRequest, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SchedulePreviewView>>;
    public previewCheckRunSchedule(body: CheckRunScheduleRequest, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling previewCheckRunSchedule.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling previewCheckRunSchedule.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SchedulePreviewView>('post',`${this.basePath}/workflows/check-run-schedules/preview`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Zeitplan fortsetzen; der Aufrufer wird ausführender Nutzer
     * 
     * @param projectId 
     * @param scheduleId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resumeCheckRunSchedule(projectId: number, scheduleId: string, observe?: 'body', reportProgress?: boolean): Observable<CheckRunScheduleView>;
    public resumeCheckRunSchedule(projectId: number, scheduleId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CheckRunScheduleView>>;
    public resumeCheckRunSchedule(projectId: number, scheduleId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CheckRunScheduleView>>;
    public resumeCheckRunSchedule(projectId: number, scheduleId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling resumeCheckRunSchedule.');
        }

        if (scheduleId === null || scheduleId === undefined) {
            throw new Error('Required parameter scheduleId was null or undefined when calling resumeCheckRunSchedule.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<CheckRunScheduleView>('post',`${this.basePath}/workflows/check-run-schedules/${encodeURIComponent(String(scheduleId))}/resume`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Zeitplan bearbeiten; der Bearbeiter wird ausführender Nutzer
     * 
     * @param body 
     * @param projectId 
     * @param scheduleId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateCheckRunSchedule(body: CheckRunScheduleRequest, projectId: number, scheduleId: string, observe?: 'body', reportProgress?: boolean): Observable<CheckRunScheduleView>;
    public updateCheckRunSchedule(body: CheckRunScheduleRequest, projectId: number, scheduleId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CheckRunScheduleView>>;
    public updateCheckRunSchedule(body: CheckRunScheduleRequest, projectId: number, scheduleId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CheckRunScheduleView>>;
    public updateCheckRunSchedule(body: CheckRunScheduleRequest, projectId: number, scheduleId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateCheckRunSchedule.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling updateCheckRunSchedule.');
        }

        if (scheduleId === null || scheduleId === undefined) {
            throw new Error('Required parameter scheduleId was null or undefined when calling updateCheckRunSchedule.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CheckRunScheduleView>('put',`${this.basePath}/workflows/check-run-schedules/${encodeURIComponent(String(scheduleId))}`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
